import { useEffect, useState } from 'react'

type Options = {
  duration?: number
  /** false の間は 0 のまま。演出の開始タイミングを外から制御する。 */
  enabled?: boolean
  /** true ならアニメーションせず即座に target を返す（演出スキップ用）。 */
  instant?: boolean
}

/** 0 から target まで ease-out でカウントアップする値を返す。 */
export function useCountUp(
  target: number,
  { duration = 1200, enabled = true, instant = false }: Options = {},
) {
  const [value, setValue] = useState(0)

  useEffect(() => {
    // 無効化・スキップ時は表示を確定させるのが目的の同期更新（演出のリセット／即時完了）
    /* eslint-disable react-hooks/set-state-in-effect */
    if (!enabled) { setValue(0); return }
    if (instant) { setValue(target); return }
    /* eslint-enable react-hooks/set-state-in-effect */
    const start = performance.now()
    let raf: number
    const tick = (now: number) => {
      const t = Math.min((now - start) / duration, 1)
      const eased = 1 - Math.pow(1 - t, 3)
      setValue(Math.round(target * eased))
      if (t < 1) raf = requestAnimationFrame(tick)
    }
    raf = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(raf)
  }, [target, duration, enabled, instant])

  return value
}

export default useCountUp
